// extracted by mini-css-extract-plugin
export var breadcrumbs = "styles-module--breadcrumbs--Uba2h";
export var linkSeparator = "styles-module--linkSeparator--B0sBU";